import styled from "styled-components";

// Sticky positioning lives on the surrounding layout section (SizeView/DesignView),
// since a sticky element can only travel within its parent box.
export const PreviewContainer = styled.div`
  position: relative;
  padding-top: 15px; // Needed to match padding in Main - AppStyle.js
  background-color: ${({ theme }) => theme.white};
  box-sizing: border-box;
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: 768px) {
    max-width: 520px;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }

  // Shadow effect in mobile view
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -10px;
    // $color-secondary-lightgrey with opacity, to transparent
    background-image: linear-gradient(
      rgba(175, 176, 179, 0.3),
      rgba(175, 176, 179, 0)
    );
    height: 10px;
    width: 100vw;

    @media (min-width: 768px) {
      display: none;
    }
  }
`;

export const FrameName = styled.h2`
  padding: 0px;
  font-size: 18px;
  text-transform: uppercase;

  @media (min-width: 480px) {
    font-size: 22px;
  }

  @media (min-width: 768px) {
    padding: 10px 0px;
    font-size: 28px;
  }
`;

export const SeasonIcon = styled.span`
  margin-right: 10px;
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const FrameSeason = styled.h3`
  font-size: 16px;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const NameAndSeason = styled.div`
  border-bottom: 1px solid lightgrey;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;

  @media (min-width: 768px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const UterumSummary = styled.div`
  margin-top: 2px;
  padding: 5px 10px 15px;

  div {  
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  @media (min-width: 768px) {
    padding: 10px 0px 0px 0px;
  }
`;

export const SquareMeterDetails = styled.span`
  font-size: 13px;
  font-weight: normal;
  margin-left: 5px;

  @media (min-width: 480px) {
    font-size: 14px;
  }
`;

export const SquareMeter = styled.span`
  font-size: 16px;
  font-weight: bold;

  @media (min-width: 480px) {
    font-size: 18px;
  }
`;

export const PriceLabel = styled.span`
  font-size: 18px;
  font-weight: bold;

  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const OrdinaryPriceLabel = styled.span`
  margin-left: 5px;
  text-decoration: line-through;
  color: ${({ theme }) => theme.grey};
  font-size: 13px;

  @media (min-width: 480px) {
    font-size: 16px;
  }
`;

export const DiscountedPrice = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.discount};

  @media (min-width: 480px) {
    font-size: 20px;
  }
`;

export const DiscountList = styled.ul`
  list-style: none;
  padding: 0;
  text-align: right;
`; 